import * as widgets_equipments_model_selectors_index from "./selectors/index.js";
import { selectors as selectors$1 } from "./slice.js";
import { actions, adapter, reducer, reducerPath, slice } from "./slice.js";
import { useContainer } from "./useContainer.js";
const selectors = {
  ...selectors$1,
  ...widgets_equipments_model_selectors_index
};
export {
  actions,
  adapter,
  reducer,
  reducerPath,
  selectors,
  slice,
  useContainer
};
